import { useCallback, useEffect } from 'react';
import { isSome } from 'fp-ts/Option';
import { useDashboard, DashboardResult, DashboardErrorResult } from 'adapter/in/dashboards/context/Dashboard';
import { GetDashboardCriteriaBuilder } from 'use-case/dashboard/get/getDashboardCriteria';

export const useReadDashboard = (
    dashboardId: string
): {
    success: boolean;
    isLoading: boolean;
    data: DashboardResult;
    error: DashboardErrorResult;
    get: () => void;
    reset: () => void;
} => {
    const { getIsLoading, getResult, getError, get, getReset } = useDashboard();

    const handleGet = useCallback(() => get(GetDashboardCriteriaBuilder.create().withId(dashboardId).build()), [dashboardId]);

    useEffect(() => {
        handleGet();
    }, [dashboardId]);

    return {
        success: !!isSome(getResult),
        isLoading: getIsLoading,
        data: getResult,
        error: getError,
        get: handleGet,
        reset: getReset,
    };
};
